module.exports = new __parcel__URL__("course_1.bfc1896d.jpg").toString();